<div class="npf-page">
  <header class="npf-topbar">
    <img src="assets/brightsidelogo.png" alt="Brightside Counseling" class="npf-logo" />
  </header>

  <!-- Dev-only testing shortcuts -->
  <div *ngIf="showTestingShortcuts && current_page != Page.DONE" class="npf-devtools">
    <label class="npf-devtools-label">
      Test email (optional)
      <input
        type="email"
        pInputText
        [(ngModel)]="devAutofillEmailInput"
        class="npf-devtools-input"
        placeholder="Blank → env or random"
      />
    </label>
    <p-button label="Auto-fill Test Data" icon="pi pi-bolt" size="small" [text]="true" (onClick)="autofillForTesting()" />
    <p-button label="Auto-fill + Go to Match" icon="pi pi-users" size="small" [text]="true" (onClick)="autofillAndGoToMatchForTesting()" />
    <p-button label="Auto-fill + Submit" icon="pi pi-send" size="small" [text]="true" (onClick)="autofillAndSubmitForTesting()" />
  </div>

  <main class="npf-shell">
    <section class="npf-card">
      <!-- Card header: back + progress -->
      <div class="npf-card-head" *ngIf="current_page != Page.DONE">
        <button
          *ngIf="current_page != Page.FIRST_NAME"
          (click)="goBack()"
          class="npf-back"
          type="button"
        >
          <i class="pi pi-chevron-left"></i><span>Back</span>
        </button>
        <span *ngIf="current_page == Page.FIRST_NAME" class="npf-back-spacer"></span>
        <p-progressbar
          *ngIf="current_page != Page.MATCH"
          class="npf-progress"
          [value]="progressPercent"
          [showValue]="false"
        ></p-progressbar>
      </div>

      <div class="npf-body">
        <!-- FIRST NAME -->
        <div *ngIf="current_page == Page.FIRST_NAME" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-user"></i> Let's get started</span>
          <h2 class="npf-title">
            What is your first name as it appears on government-issued documents?
          </h2>
          <p class="npf-subtitle">We'll use this to personalize your experience.</p>
          <div class="npf-field">
            <input
              [autofocus]=""
              #FIRST_NAME
              pInputText
              [(ngModel)]="firstName"
              type="text"
              class="npf-input"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
              placeholder="Type your first name here"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- LAST NAME -->
        <div *ngIf="current_page == Page.LAST_NAME" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-user"></i> About you</span>
          <h2 class="npf-title">
            What is your last name as it appears on government-issued documents?
          </h2>
          <p class="npf-subtitle">We'll use this to personalize your experience.</p>
          <div class="npf-field">
            <input
              [autofocus]=""
              #LAST_NAME
              pInputText
              [(ngModel)]="lastName"
              type="text"
              class="npf-input"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
              placeholder="Type your last name here"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- EMAIL -->
        <div *ngIf="current_page == Page.EMAIL" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-envelope"></i> Contact</span>
          <h2 class="npf-title">What's your email?</h2>
          <p class="npf-subtitle">We'll use this to send you appointment reminders.</p>
          <div class="npf-field">
            <input
              [autofocus]=""
              #EMAIL
              pInputText
              [(ngModel)]="email"
              type="text"
              class="npf-input"
              placeholder="Type your preferred email here"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
            />
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="email_consent" [binary]="true" inputId="emailConsent" />
              <label for="emailConsent">
                By checking this box, I consent to receiving emails from Brightside Counseling.
              </label>
            </div>
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="newsletter" [binary]="true" inputId="newsletter" />
              <label for="newsletter">
                I'd like to receive Brightside Counseling's newsletter with free mental health
                tips, tools, and perspective.
              </label>
            </div>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- PHONE -->
        <div *ngIf="current_page == Page.PHONE" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-phone"></i> Contact</span>
          <h2 class="npf-title">What's your phone number?</h2>
          <p class="npf-subtitle">
            We'll use this to send you appointment reminders and important information.
          </p>
          <div class="npf-field">
            <input
              [autofocus]=""
              #PHONE
              pInputText
              [(ngModel)]="tn"
              type="tel"
              class="npf-input"
              placeholder="Type your mobile number here"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
            />
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="tn_consent" [binary]="true" inputId="tnConsent" />
              <label for="tnConsent">
                By checking this box, I consent to receiving SMS messages from Brightside
                Counseling for appointment reminders.
              </label>
            </div>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- ADDRESS -->
        <div *ngIf="current_page == Page.ADDR" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-map-marker"></i> Address</span>
          <h2 class="npf-title">What's your home address?</h2>
          <div class="npf-field npf-field--form">
            <label class="npf-label">Full Street Address</label>
            <input
              [autofocus]=""
              #ADDR
              pInputText
              [(ngModel)]="street"
              type="text"
              class="npf-input"
              placeholder="Type your street here"
            />
            <label class="npf-label">City Name</label>
            <input
              pInputText
              [(ngModel)]="city"
              type="text"
              class="npf-input"
              placeholder="Type your city here"
            />
            <label class="npf-label">State</label>
            <p-select
              [(ngModel)]="state"
              [options]="usStates"
              optionLabel="label"
              optionValue="value"
              placeholder="Select your state"
              [filter]="true"
              filterBy="label"
              styleClass="npf-select"
              appendTo="body"
            ></p-select>
            <label class="npf-label">Zip Code</label>
            <input
              pInputText
              [(ngModel)]="zipCode"
              type="text"
              class="npf-input"
              placeholder="Type your zip code here"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- FUN FACT -->
        <div *ngIf="current_page == Page.FUNFACT" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-heart"></i> You're on your way</span>
          <h2 class="npf-title">Benefits are coming, {{ firstName }}</h2>
          <p class="npf-prose">
            Fun fact: hundreds of studies have found that therapy helps people make positive
            changes in their lives. These studies show that 75% of people who enter therapy
            experience therapeutic benefits.
            <br /><br />
            You're on your way! Let's keep going.
          </p>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- DOB -->
        <div *ngIf="current_page == Page.DOB" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-calendar"></i> About you</span>
          <h2 class="npf-title">What's your date of birth?</h2>
          <div class="npf-field">
            <input
              [autofocus]=""
              placeholder="mm/dd/yyyy"
              #DOB
              max="{{ maxDate }}"
              min="1900-01-01"
              [(ngModel)]="dob"
              type="date"
              pInputText
              class="npf-input npf-input--date"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- GENDER -->
        <div *ngIf="current_page == Page.GENDER" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-id-card"></i> About you</span>
          <h2 class="npf-title">What's your gender?</h2>
          <div class="npf-field">
            <p-select
              [autofocus]=""
              #GENDER
              [(ngModel)]="gender"
              [options]="genderOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              styleClass="npf-select"
              appendTo="body"
            ></p-select>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- PRACTICE -->
        <div *ngIf="current_page == Page.PRACTICE" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-building"></i> Location</span>
          <h2 class="npf-title">Which office location do you prefer?</h2>
          <div class="npf-choice-grid">
            <button type="button" class="npf-choice" (click)="practice = 'pa'; nextPage()">
              <i class="pi pi-map-marker npf-choice-icon"></i>
              <span class="npf-choice-title">Harleysville, PA</span>
              <span class="npf-choice-sub">681 Harleysville Pike<br />2nd Floor<br />Harleysville, PA 19438</span>
            </button>
            <button type="button" class="npf-choice" (click)="practice = 'philly'; type_of_care = 'therapy'; nextPage()">
              <i class="pi pi-map-marker npf-choice-icon"></i>
              <span class="npf-choice-title">Philadelphia, PA</span>
              <span class="npf-choice-sub">150 Monument Rd.<br />Bala Cynwyd, PA 19004</span>
            </button>
            <button type="button" class="npf-choice" (click)="practice = 'va'; type_of_care = 'therapy'; nextPage()">
              <i class="pi pi-map-marker npf-choice-icon"></i>
              <span class="npf-choice-title">Norfolk, VA</span>
              <span class="npf-choice-sub">999 Waterside Drive<br />Suite 2606<br />Norfolk, VA 23510</span>
            </button>
          </div>
        </div>

        <!-- CARE -->
        <div *ngIf="current_page == Page.CARE" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-users"></i> Care</span>
          <h2 class="npf-title">Who will be receiving care?</h2>
          <div class="npf-choice-grid">
            <button type="button" class="npf-choice npf-choice--media" (click)="care = 'individual'; nextPage()">
              <img src="assets/individual.png" alt="Individual" />
              <span class="npf-choice-title">Individual</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="care = 'couple'; nextPage()">
              <img src="assets/couple.png" alt="Couple" />
              <span class="npf-choice-title">Couple</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="care = 'child'; nextPage()">
              <img src="assets/child.png" alt="Child" />
              <span class="npf-choice-title">Child (under 10)</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="care = 'adolescent'; nextPage()">
              <img src="assets/adolescent.png" alt="Adolescent" />
              <span class="npf-choice-title">Adolescent (10-18)</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="care = 'family'; nextPage()">
              <img src="assets/family.png" alt="Family" />
              <span class="npf-choice-title">Family</span>
            </button>
          </div>
        </div>

        <!-- TYPE OF CARE -->
        <div *ngIf="current_page == Page.TYPE_OF_CARE" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-compass"></i> Care</span>
          <h2 class="npf-title">What type of care are you seeking?</h2>
          <div class="npf-choice-grid">
            <button type="button" class="npf-choice npf-choice--media" (click)="type_of_care = 'therapy'; nextPage()">
              <img src="assets/therapy.png" alt="Therapy" />
              <span class="npf-choice-title">Therapy / Coaching</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="type_of_care = 'medical'; nextPage()">
              <img src="assets/doc.png" alt="Psychiatry" />
              <span class="npf-choice-title">Psychiatry / Medical</span>
            </button>
          </div>
        </div>

        <!-- GENETIC TESTING -->
        <div *ngIf="current_page == Page.GENETIC_TESTING" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-sparkles"></i> Genetic testing</span>
          <h2 class="npf-title">Would you be interested in genetic testing?</h2>
          <p class="npf-subtitle">
            <a href="https://genesight.com/" target="_blank">Genetic Testing</a> has proven to
            help clients find the right medication for their body.
          </p>
          <div class="npf-choice-grid">
            <button type="button" class="npf-choice npf-choice--media" (click)="genetic_testing = true; nextPage()">
              <img src="assets/genes.png" alt="Genetic testing" />
              <span class="npf-choice-title">Yes!</span>
            </button>
          </div>
          <p-button label="No, thank you" [text]="true" styleClass="npf-textlink" (onClick)="genetic_testing = false; nextPage()" />
        </div>

        <!-- GENETIC TESTING 2 -->
        <div *ngIf="current_page == Page.GENETIC_TESTING2" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-sparkles"></i> Genetic testing</span>
          <h2 class="npf-title">How would you like your genetic test administered?</h2>
          <p class="npf-subtitle">
            Take the test in the comfort of your own home, or stop by and have our medical
            professionals administer it.
          </p>
          <div class="npf-choice-grid">
            <button type="button" class="npf-choice npf-choice--media" (click)="genetic_testing_method = 'ship'; nextPage()">
              <img src="assets/envelope.png" alt="Ship home" />
              <span class="npf-choice-title">Ship to My Home</span>
            </button>
            <button type="button" class="npf-choice npf-choice--media" (click)="genetic_testing_method = 'office'; nextPage()">
              <img src="assets/dr.png" alt="In office" />
              <span class="npf-choice-title">Brightside Main Office (701 Cross Road, Lederach, PA 19450)</span>
            </button>
          </div>
        </div>

        <!-- INSURANCE DISCLAIMERS -->
        <div *ngIf="current_page == Page.INS_DISCLAIMER" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-shield"></i> Insurance</span>
          <h2 class="npf-title">Insurance Disclaimers</h2>
          <p class="npf-subtitle npf-subtitle--italic">*Please accept the following disclaimers*</p>
          <div class="npf-field npf-field--form">
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="disclaimer1" [binary]="true" inputId="disclaimer1" />
              <label for="disclaimer1">
                Use your full name as written on your government-issued ID when providing
                information.
              </label>
            </div>
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="disclaimer2" [binary]="true" inputId="disclaimer2" />
              <label for="disclaimer2">
                Double check your insurance card to ensure the accurate insurance plan is
                selected.
              </label>
            </div>
            <div class="npf-consent">
              <p-checkbox [(ngModel)]="disclaimer3" [binary]="true" inputId="disclaimer3" />
              <label for="disclaimer3">
                Please note that we DO NOT accept state insurance (Medicaid/CHIP/Medicare).
              </label>
            </div>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- INSURANCE -->
        <div *ngIf="current_page == Page.INS" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-shield"></i> Insurance</span>
          <h2 class="npf-title">What insurance do you have?</h2>
          <p class="npf-subtitle npf-subtitle--italic">
            *If we do not accept your insurance, we will be happy to discuss a private pay option
            for services.*
          </p>
          <div class="npf-field npf-field--form">
            <label class="npf-label">Insurance Provider</label>
            <p-select
              #INS
              [(ngModel)]="provider"
              [options]="insuranceProviders"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              [filter]="true"
              filterBy="label"
              styleClass="npf-select"
              appendTo="body"
            ></p-select>

            <ng-container *ngIf="provider != 'Out of Pocket/Other' && provider != ''">
              <label class="npf-label">Member ID/Group #</label>
              <input
                [autofocus]=""
                pInputText
                [(ngModel)]="memberId"
                type="text"
                class="npf-input"
                placeholder="Member ID"
              />
              <label class="npf-label">Relationship to Subscriber (Policyholder)</label>
              <p-select
                [(ngModel)]="relationshipToInsured"
                [options]="subscriberRelationshipOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                styleClass="npf-select"
                appendTo="body"
                (onChange)="updateSelfAttributes()"
              ></p-select>
              <label class="npf-label">Subscriber's First Name</label>
              <input
                pInputText
                [(ngModel)]="cardHolderFirst"
                type="text"
                class="npf-input"
                placeholder="First Name"
              />
              <label class="npf-label">Subscriber's Last Name</label>
              <input
                pInputText
                [(ngModel)]="cardHolderLast"
                type="text"
                class="npf-input"
                placeholder="Last Name"
              />
              <label class="npf-label">Subscriber's Date of Birth</label>
              <input
                [(ngModel)]="cardHolderDob"
                max="{{ maxDate }}"
                min="1900-01-01"
                type="date"
                pInputText
                class="npf-input npf-input--date"
              />
            </ng-container>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- INSURANCE CARD -->
        <div *ngIf="current_page == Page.INS_CARD" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-id-card"></i> Insurance</span>
          <h2 class="npf-title">Upload your Insurance Card</h2>
          <p class="npf-subtitle">Please add a clear photo of the front and back.</p>
          <div class="npf-field npf-field--form">
            <span class="npf-uploadlabel">Front of Card</span>
            <div
              class="npf-upload"
              [class.shake]="shakeFrontInput"
              (dragover)="onDragOver($event, 'front')"
              (dragleave)="onDragLeave('front')"
              (drop)="onDrop($event, 'front')"
            >
              <input id="front" type="file" (change)="onFrontImageSelect($event)" accept="image/*" />
              <div class="npf-upload-hint" *ngIf="!frontImage">
                <i class="pi pi-cloud-upload"></i>
                <span>Drag &amp; drop or click to upload</span>
              </div>
              <div *ngIf="frontImage" class="npf-upload-preview">
                <img [src]="frontImage" alt="Front of card" />
                <button type="button" class="npf-upload-remove" (click)="removeFrontImage()">
                  <i class="pi pi-times"></i> Remove
                </button>
              </div>
            </div>

            <span class="npf-uploadlabel">Back of Card</span>
            <div
              class="npf-upload"
              [class.shake]="shakeBackInput"
              (dragover)="onDragOver($event, 'back')"
              (dragleave)="onDragLeave('back')"
              (drop)="onDrop($event, 'back')"
            >
              <input id="back" type="file" (change)="onBackImageSelect($event)" accept="image/*" />
              <div class="npf-upload-hint" *ngIf="!backImage">
                <i class="pi pi-cloud-upload"></i>
                <span>Drag &amp; drop or click to upload</span>
              </div>
              <div *ngIf="backImage" class="npf-upload-preview">
                <img [src]="backImage" alt="Back of card" />
                <button type="button" class="npf-upload-remove" (click)="removeBackImage()">
                  <i class="pi pi-times"></i> Remove
                </button>
              </div>
            </div>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- LAST DETAILS -->
        <div *ngIf="current_page == Page.LAST_DETAILS" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-list"></i> Almost there</span>
          <h2 class="npf-title">Some last details...</h2>
          <div class="npf-field npf-field--form">
            <label class="npf-label">Primary Care Physician and Zip Code</label>
            <input
              [autofocus]=""
              #LAST_DETAILS
              pInputText
              [(ngModel)]="primaryCare"
              type="text"
              class="npf-input"
              placeholder="Doctor/Clinic Name & Zip Code"
            />
            <label class="npf-label">Referred By</label>
            <input
              pInputText
              [(ngModel)]="referredBy"
              type="text"
              class="npf-input"
              placeholder="Full Name"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- PHARMACY -->
        <div *ngIf="current_page == Page.PHARMACY" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-plus-circle"></i> Pharmacy</span>
          <h2 class="npf-title">Your preferred pharmacy details</h2>
          <div class="npf-field npf-field--form">
            <label class="npf-label">Pharmacy Name</label>
            <input [autofocus]="" pInputText [(ngModel)]="pharmacyName" type="text" class="npf-input" placeholder="Pharmacy name" />
            <label class="npf-label">Pharmacy Street Address</label>
            <input pInputText [(ngModel)]="pharmacyStreet" type="text" class="npf-input" placeholder="Street address" />
            <label class="npf-label">City</label>
            <input pInputText [(ngModel)]="pharmacyCity" type="text" class="npf-input" placeholder="City" />
            <label class="npf-label">State (2-letter code)</label>
            <input pInputText [(ngModel)]="pharmacyState" type="text" maxlength="2" class="npf-input" placeholder="PA" />
            <label class="npf-label">Zip Code</label>
            <input pInputText [(ngModel)]="pharmacyZip" type="text" maxlength="5" class="npf-input" placeholder="19438" />
            <label class="npf-label">Pharmacy Phone Number (Optional)</label>
            <input
              pInputText
              [(ngModel)]="pharmacyTn"
              type="tel"
              class="npf-input"
              placeholder="(215) 555-1234"
              (keyup.enter)="!verify(current_page) ? nextPage() : null"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- EMERGENCY CONTACTS -->
        <div *ngIf="current_page == Page.EMERGENCY_CONTACTS" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-phone"></i> Emergency contact</span>
          <h2 class="npf-title">Emergency contact information</h2>
          <p class="npf-subtitle">
            Please share at least one person we can contact in an emergency. You can add more if
            you'd like.
          </p>
          <div class="npf-field npf-field--form">
            <div *ngFor="let contact of emergencyContacts; let i = index" class="npf-ec-row">
              <div class="npf-ec-caption" *ngIf="emergencyContacts.length > 1">Contact {{ i + 1 }}</div>
              <label class="npf-label">Full Name</label>
              <input pInputText [(ngModel)]="contact.name" [name]="'ecName' + i" type="text" class="npf-input" placeholder="Full name" />
              <label class="npf-label">Relationship</label>
              <p-select
                [(ngModel)]="contact.relationship"
                [name]="'ecRel' + i"
                [options]="emergencyContactRelationships"
                optionLabel="label"
                optionValue="value"
                placeholder="Select relationship"
                styleClass="npf-select"
                appendTo="body"
              ></p-select>
              <label class="npf-label">Phone Number</label>
              <input pInputText [(ngModel)]="contact.phone" [name]="'ecPhone' + i" type="tel" class="npf-input" placeholder="(215) 555-1234" />
              <p-button
                *ngIf="emergencyContacts.length > 1"
                label="Remove this contact"
                icon="pi pi-trash"
                severity="danger"
                [text]="true"
                size="small"
                (onClick)="removeEmergencyContact(i)"
              />
            </div>
            <p-button
              label="Add another contact"
              icon="pi pi-plus"
              [outlined]="true"
              styleClass="npf-addbtn"
              (onClick)="addEmergencyContact()"
            />
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- INTERFACE -->
        <div *ngIf="current_page == Page.INTERFACE" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-desktop"></i> Preferences</span>
          <h2 class="npf-title">How would you like to interface with your provider?</h2>
          <div class="npf-options">
            <button type="button" class="npf-option" (click)="interface = 'In-Person'; nextPage()">In-Person</button>
            <button type="button" class="npf-option" (click)="interface = 'Virtual'; nextPage()">Virtual</button>
            <button type="button" class="npf-option" (click)="interface = 'Either'; nextPage()">Either</button>
          </div>
        </div>

        <!-- DAY PREF -->
        <div *ngIf="current_page == Page.DAY_PREF" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-calendar"></i> Preferences</span>
          <h2 class="npf-title">What days do you prefer?</h2>
          <div class="npf-options">
            <button type="button" class="npf-option" (click)="dayPreference = 'Weekdays'; nextPage()">Weekdays</button>
            <button type="button" class="npf-option" (click)="dayPreference = 'Weekends'; nextPage()">Weekends</button>
            <button type="button" class="npf-option" (click)="dayPreference = 'Either'; nextPage()">No Preference / Next Available</button>
          </div>
        </div>

        <!-- TIME PREF -->
        <div *ngIf="current_page == Page.TIME_PREF" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-clock"></i> Preferences</span>
          <h2 class="npf-title">Which time of the day do you prefer?</h2>
          <div class="npf-pills">
            <button
              type="button"
              class="npf-pill"
              [class.is-selected]="timePreference.includes('Morning')"
              (click)="updateElement(timePreference, 'Morning')"
            >Morning</button>
            <button
              type="button"
              class="npf-pill"
              [class.is-selected]="timePreference.includes('Afternoon')"
              (click)="updateElement(timePreference, 'Afternoon')"
            >Afternoon</button>
            <button
              type="button"
              class="npf-pill"
              [class.is-selected]="timePreference.includes('Evening')"
              (click)="updateElement(timePreference, 'Evening')"
            >Evening</button>
            <button
              type="button"
              class="npf-pill"
              [class.is-selected]="timePreference.includes('No Preference / Next Available')"
              (click)="updateElement(timePreference, 'No Preference / Next Available')"
            >No Preference / Next Available</button>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- SPECIALTIES -->
        <div *ngIf="current_page == Page.SPECIALTIES" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-star"></i> Preferences</span>
          <h2 class="npf-title">What would you like your provider to specialize in?</h2>
          <p class="npf-subtitle">We'll use this to personalize your experience. Select at least one.</p>
          <div class="npf-pills">
            <button
              type="button"
              class="npf-pill"
              *ngFor="let s of specialtyOptions"
              [class.is-selected]="specialties.includes(s)"
              (click)="updateElement(specialties, s)"
            >{{ s }}</button>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- GENDER PREF -->
        <div *ngIf="current_page == Page.GENDER_PREF" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-user"></i> Preferences</span>
          <h2 class="npf-title">What is your gender preference for your provider?</h2>
          <div class="npf-pills">
            <button
              type="button"
              class="npf-pill"
              *ngFor="let g of genderPreferenceOptions"
              [class.is-selected]="genderPreferences.includes(g)"
              (click)="updateElement(genderPreferences, g)"
            >{{ g }}</button>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="nextPage()" />
        </div>

        <!-- ETHNICITY -->
        <div *ngIf="current_page == Page.ETHNICITIY" class="npf-step">
          <span class="npf-eyebrow"><i class="pi pi-globe"></i> Preferences</span>
          <h2 class="npf-title">
            Are you hoping to work with a provider who identifies with a specific
            ethnicity/ethnicities?
          </h2>
          <div class="npf-pills">
            <button
              type="button"
              class="npf-pill"
              *ngFor="let e of ethnicityOptions"
              [class.is-selected]="ethnicities.includes(e)"
              (click)="updateElement(ethnicities, e)"
            >{{ e }}</button>
          </div>
          <p-button label="Continue" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" [disabled]="verify(current_page)" (onClick)="match()" />
        </div>

        <!-- MATCH -->
        <div *ngIf="current_page == Page.MATCH" class="npf-step">
          <div *ngIf="isSubmittingFromMatch" class="npf-match-loading">
            <p-progressSpinner styleClass="npf-spinner" strokeWidth="4" />
            <p>Creating your patient portal account...</p>
          </div>
          <h2 class="npf-title" *ngIf="matchData.length > 0">
            Great news! We've matched you to clinicians that best suit your needs.
          </h2>
          <h2 class="npf-title" *ngIf="matchData.length == 0">
            We're matching you to a clinician that best suits your needs.
          </h2>

          <div *ngIf="matchData.length == 0" class="npf-match-loading">
            <p-progressSpinner styleClass="npf-spinner" strokeWidth="4" />
          </div>

          <div *ngIf="matchData.length > 0" class="npf-clin-grid">
            <article *ngFor="let c of see_more ? matchData : matchData.slice(0, 3)" class="npf-clin-card">
              <img [src]="c.img_url" alt="{{ c.name }}" class="npf-clin-img" />
              <h3 class="npf-clin-name">{{ c.name }}</h3>
              <p class="npf-clin-spec">{{ c.specialties }}</p>
              <span class="npf-clin-score" *ngIf="c?.score">{{ c.score }}% Match</span>
              <p-button
                label="Select"
                styleClass="npf-cta"
                [disabled]="isSubmittingFromMatch"
                (onClick)="submitFromMatch(c.clinicianId, c.name)"
              />
            </article>
          </div>

          <div class="npf-match-actions" *ngIf="matchData.length > 0">
            <p-button
              *ngIf="!see_more && practice != 'va'"
              label="See more clinicians"
              icon="pi pi-chevron-down"
              [text]="true"
              [disabled]="isSubmittingFromMatch"
              (onClick)="see_more = !see_more"
            />
            <p-button
              *ngIf="see_more && practice != 'va'"
              label="See fewer"
              icon="pi pi-chevron-up"
              [text]="true"
              [disabled]="isSubmittingFromMatch"
              (onClick)="see_more = !see_more"
            />
            <p-button
              label="I'm not sure. Assign a clinician for me."
              [outlined]="true"
              styleClass="npf-match-secondary"
              [disabled]="isSubmittingFromMatch"
              (onClick)="submitFromMatch('Unsure')"
            />
            <p-button
              label="I would like to see the next available clinician"
              [outlined]="true"
              styleClass="npf-match-secondary"
              [disabled]="isSubmittingFromMatch"
              (onClick)="submitFromMatch('Flex')"
            />
          </div>
        </div>

        <!-- DONE -->
        <div *ngIf="current_page == Page.DONE" class="npf-step npf-step--done">
          <div *ngIf="submitStatus == 'loading'" class="npf-match-loading">
            <p-progressSpinner styleClass="npf-spinner" strokeWidth="4" />
            <p>Submitting your form...</p>
          </div>

          <ng-container *ngIf="submitStatus == 'success'">
            <div class="npf-done-icon npf-done-icon--success"><i class="pi pi-check"></i></div>
            <h1 class="npf-done-title">Thank you!</h1>
            <p class="npf-prose">We have received your form. We will be in touch shortly.</p>
          </ng-container>

          <ng-container *ngIf="submitStatus == 'error'">
            <div class="npf-done-icon npf-done-icon--error"><i class="pi pi-times"></i></div>
            <h1 class="npf-done-title npf-done-title--error">Submission Failed</h1>
            <p class="npf-prose npf-prose--error">
              We're sorry, but there was an error submitting your form. Please try again or contact
              our team at (215) 264-2272 for assistance.
            </p>
            <p-button label="Try Again" icon="pi pi-refresh" styleClass="npf-cta" (onClick)="submit()" />
          </ng-container>
        </div>
      </div>

      <p class="npf-footnote" *ngIf="current_page != Page.DONE && current_page != Page.MATCH">
        Tell us about your preferences. We'll do our best to match you with a therapist or coach
        tailored to your unique needs.
      </p>
    </section>
  </main>
</div>
